export enum ContactType {
    Pai = 1,
    Mae = 2,
    TiaOuTio = 3,
    Conjuge = 4,
    Outros = 5
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ContactType.ts